const routePaths = {
  VERIFY: '/verify/:code',
  LOGIN: '/login',
  HOME: '/',
  DASHBOARD: '/dashboard',
  GROUP: '/dashboard/group/:groupId',
  RESIDENT: '/resident/:residentId',
  USER: '/user/:userId',
  CARE_PLAN: '/care-plan',
  CARE_PLAN_2: '/care-plan-2',
  CARE_PLAN_3: '/care-plan-3',
  CARE_PLAN_4: '/care-plan-4',
  CONSULTATION: '/consultation',
  BIOGRAPHY: '/biography',
  NURSE_VISIT: '/nurse-visit',
  REPORT: '/report',
  BASE_DATA: '/base-data',
  DATA_EMPLOYEE: '/base-data/employee/:entityId',
  DATA_RESIDENT: '/base-data/resident/:entityId',
  DATA_DOCTOR: '/base-data/doctor/:entityId',
  DATA_INSURANCE: '/base-data/insurance/:entityId',
  DATA_WELFARE_OFFICE: '/base-data/welfare-office/:entityId',
  DATA_GENERAL: '/general',
  DATA_CONTRACT: '/contract',
  DATA_ACCESS: '/system-access',
  DATA_ADVICE_CONSULTATION: '/advice-consultation',
  DATA_CHECKLIST: '/checklist',
  DATA_CONTACTS: '/contacts',
  DATA_PASTORAL_CARE: '/pastoral-care',
  DATA_UTENSILS: '/utensils',
  DATA_INVOICING: '/invoicing',
  DATA_DOCUMENT_MANAGEMENT: '/document-management',
  DATA_ADD_RESIDENT: '/base-data/add-resident/',
  DATA_ADD_EMPLOYEE: '/base-data/add-employee/',
  DATA_ADD_DOCTOR: '/base-data/add-doctor/',
  DATA_ADD_INSURANCE: '/base-data/add-insurance/',
  DATA_ADD_WELFARE_OFFICE: '/base-data/add-welfare-office/',
  NURSING: '/nursing-report',
  NOT_FOUND: '/not-found',
  INACTIVE: '/inactive',
  APPLICANT: '/applicant',
  ABSENT: '/absent',
  DELETED: '/deleted',

  HEALTH: '/health',
  HEALTH_MEDICATION: '/health/medication',
  HEALTH_VISIT_SHEET: '/health/visit-sheet',
  HEALTH_DOCTORS_DIAGNOSES: '/health/doctors-diagnoses',
  HEALTH_VITAL_INFORMATION: '/health/vital-information',

  ASSESSMENTS: '/assessments',
  MOVEMENT_STATUS: '/assessments/movement-status',
  RISK_OF_FALLING: '/assessments/risk-of-falling',
  DECUBITUS_RISK: '/assessments/decubitus-risk',

  EXECUTION: '/execution',
  EX_MAINTENNANCE: '/execution/maintenance',
  EX_SOCIAL_CARE: '/execution/social-care',
  EX_MONTHLY_OVERVIEW: '/execution/monthly-overview',

  LOGS: '/logs',
  WOUND_DOCUMENTATION: '/logs/wound-documentation',
  PAIN_ASSESSMENT: '/logs/pain-assessment',
  NUTRITION_DRINKING_LOG: '/logs/nutrition-drinking-log',
  FALL_PROTOCOL: '/logs/fall-protocol',
  VITAL_SIGN: '/logs/vital-sign',

  EXAL_CARE_ROUNDS: '/evaluation/care-rounds',
  EXAL_APPRAISAL: '/evaluation/appraisal',
  EXAL_INDICATORS: '/evaluation/indicators',
  EXAL_CARE_DISCUSSION: '/evaluation/case_discussion',

  // Config menu
  CONFIGURATION: '/configuration',
  CONFIGURATION_HOUSE_DIVISIONS: '/configuration/house-divisions',
  CONFIGURATION_ROSTER: '/configuration/roster',
  CONFIGURATION_SUGGESTIONS: '/configuration/suggestions',
  CONFIGURATION_HOUSE_DATA: '/configuration/house-data',
  CONFIGURATION_CARE_DOCUMENTATION: '/configuration/care-documentation',
  CONFIGURATION_INDICATORS_TRANSMISSION: '/configuration/indicators',
  CONFIGURATION_INVOICING: '/configuration/invoicing',
  CONFIGURATION_FIBU: '/configuration/fibu',
  CONFIGURATION_BOOKING_ACCOUNTS: '/configuration/booking-accounts',
  CONFIGURATION_CASH_ITEMS: '/configuration/cash-items',

  // Pflegegrad Einstufung
  PFLEGEGRAD_ASSESSMENT: '/pflegegrad-assessment',

  // Roster Menu
  ROSTER: 'https://dienstplan.doku-coach.de/account/login',

  // Lists menu
  LISTS: '/lists',
  LISTS_MEDICATION: '/lists/medication',
  LISTS_VISIT_SHEET_QUESTIONS: '/lists/visit-sheet-questions',
  LISTS_NURSING_OVERVIEW: '/lists/nursing-overview',
  LISTS_RISK_GROUPS: '/lists/risk-groups',
  LISTS_RISK_LIST: '/lists/risk-list',
  LISTS_BASE_DATA_GENERAL: '/lists/base-data-general',
  LISTS_BASE_DATA_REFERENCE_CARE: '/lists/base-data-reference-care',
  LISTS_BASE_DATA_CONSULTING: '/lists/base-data-consulting',
  LISTS_EXTERNAL_INFORMATION: '/lists/external-information',
  LISTS_BASE_DATA_KV: '/lists/base-data-kv',
  LISTS_MEDICATION_ORDERS: '/lists/medication-orders',
  LISTS_EMPLOYEE_BASE_DATA_GENERAL: '/lists/employee-base-data-general',
  LISTS_FREE_BEDS: '/lists/free-beds',
  LISTS_OCCUPANCY_INDICATOR: '/lists/occupancy-indicator',

  // Indicators menu
  INDICATORS: '/indicators',
  INDICATORS_AUDIT: '/indicators/audit',
  INDICATORS_TRANSMISSION: '/indicators/transmission',
  INDICATORS_ARCHIVE: '/indicators/archive',

  // Invoicing menu
  INVOICING: '/invoicing',
  INVOICING_OVERVIEW: '/invoicing/overview',
  INVOICING_OPEN: '/invoicing/open',
  INVOICE: '/invoice/:invoiceId',
  EXECUTION_PLAN_PREVIEW: '/plan/:executionPlanId',
  INVOICING_BALANCES: '/invoicing/balances',
  INVOICING_INCOMES: '/invoicing/incomes',
  INVOICING_CARE: '/invoicing/care',
  RESIDENTS_WITHOUT_INVOICE: '/invoicing/residents-without-invoice',
  SEPA: '/invoicing/sepa',
  FIBU: '/invoicing/fibu',
  FIBU_CASH: '/invoicing/fibu-cash',
  SEPA_POCKET: '/invoicing/sepa-pocket',
  INVOICING_CASH_BALANCE: '/invoicing/cash-balance',
};

export default routePaths;
